<div class="container-fluid" style=" padding-right: 0px; padding-left: 0px">
  <app-nav-menu></app-nav-menu>
</div>
<div class="container" id="desktop">
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:2.6em; font-weight:bold">
      Key Contacts
    </div>
  </div>
  <div class="table-responsive mt-4">
    <table class="table table-bordered image-table">
      <tbody>
        <tr>
          <td style="font-weight:bold; vertical-align:middle; width:25%">
            <img class="brand__logo" src="../../../assets/images/HeadshotChristianLevisLowey.jpg" alt="">
            Christian Levis<br />
            Lowey Dannenberg, PC<br />
          </td>
          <td style="vertical-align:middle; width:75%">
            Christian Levis is a Partner in the New York office of Lowey Dannenberg and Head of the Firm&rsquo;s Data Breach and Privacy Practice. An award-winning litigator, Mr. Levis is recognized
            as one of the top 500 cyber lawyers and plaintiffs&rsquo; lawyers in the world, and a two-time honoree by the American Antitrust Institute for outstanding achievement in private
            enforcement.
          </td>
        </tr>
        <tr>
          <td style="font-weight:bold; vertical-align:middle; width:25%">
            <img class="brand__logo" src="../../../assets/images/120922L_Timothy_Fisher041_400_400.jpg" alt="">
            L. Timothy Fisher<br />
            Bursor &amp; Fisher, P.A.<br />
          </td>
          <td style="vertical-align:middle; width:75%">
            L. Timothy Fisher is the Managing Partner of Bursor &amp; Fisher&rsquo;s California office. He has an active practice in consumer class actions and complex business litigation and
            has also successfully handled a large number of civil appeals.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="container" id="mobile">
  <div class="row mt-2">
    <div class="col-md-12" style="font-size:2.0em; font-weight:bold">
      Key Contacts
    </div>
  </div>
  <div class="table-responsive mt-4">
    <table class="table table-bordered image-table">
      <tbody>
        <tr>
          <td style="font-weight: bold; vertical-align: middle; width: 25%; font-size: .8em">
            <img class="brand__logo" src="../../../assets/images/HeadshotChristianLevisLowey.jpg" alt="">
            Christian Levis<br />
            Lowey Dannenberg, PC<br />
          </td>
          <td style="vertical-align: middle; width: 75%; font-size: .8em">
            Christian Levis is a Partner in the New York office of Lowey Dannenberg and Head of the Firm&rsquo;s Data Breach and Privacy Practice. An award-winning litigator, Mr. Levis is recognized
            as one of the top 500 cyber lawyers and plaintiffs&rsquo; lawyers in the world, and a two-time honoree by the American Antitrust Institute for outstanding achievement in private
            enforcement.
          </td>
        </tr>
        <tr>
          <td style="font-weight: bold; vertical-align: middle; width: 25%; font-size: .8em">
            <img class="brand__logo" src="../../../assets/images/120922L_Timothy_Fisher041_400_400.jpg" alt="">
            L. Timothy Fisher<br />
            Bursor &amp; Fisher, P.A.<br />
          </td>
          <td style="vertical-align: middle; width: 75%; font-size: .8em">
            L. Timothy Fisher is the Managing Partner of Bursor &amp; Fisher&rsquo;s California office. He has an active practice in consumer class actions and complex business litigation and
            has also successfully handled a large number of civil appeals.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>


<br />



